// アプリケーション全体で使用する定数を定義します

// 一覧の1ページ表示数
export const LIST_ITEM_MAX_COUNT = 20;